/**
 * Created by admin on 2018/5/8.
 */
import React, { PureComponent } from 'react';
import { connect } from 'dva';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, Input, Modal, Table } from 'antd';
import './SupportManage.less';
import SupportEditModal from '../../components/account/SupportEditModal';
import { OperateSpan } from '../../components/Widgets';
import IconTip from '../../components/IconTip';

class SupportManage extends PureComponent {
  static defaultProps = {
    allSupports: [],
    frontDeskPhone: ''
  };

  constructor() {
    super();
    this.state = {
      editSupport: {},
      editDeskPhone: false,
      showEdit: false
    };
  }

  render() {
    const { allSupports, dispatch, frontDeskPhone, intl } = this.props;
    const { editSupport, showEdit, editDeskPhone } = this.state;
    return (
      <div className="support-Management">
        <div className="support-list-head">
          <span>
            <FormattedMessage id="support_manage_list" />
          </span>
          <div className="suffix-wrapper">
            <div className="desk-phone">
              <span>
                <FormattedMessage id="support_manage_receptionist_number" />：
              </span>
              {editDeskPhone ? (
                <Input
                  value={frontDeskPhone}
                  onChange={this.onChangeFrontDeskPhone}
                  onPressEnter={this.onSaveFrontDeskPhone}
                  onBlur={this.onSaveFrontDeskPhone}
                />
              ) : (
                <span>
                  {frontDeskPhone
                    ? frontDeskPhone
                    : this.props.intl.formatMessage({
                        id: 'support_manage_front_empty'
                      })}
                  <IconTip
                    title={intl.formatMessage({
                      id: 'support_manage_receptionist_edit'
                    })}
                    type="75bianji"
                    size="14"
                    onClick={() => this.setState({ editDeskPhone: true })}
                  />
                </span>
              )}
            </div>
            <Button type="primary" icon="plus" onClick={this.toggleEdit}>
              <FormattedMessage id="support_manage_btn_add" />
            </Button>
          </div>
        </div>
        <Table
          columns={[
            {
              title: intl.formatMessage({ id: 'support_manage_name' }),
              dataIndex: 'name',
              key: 'name'
            },
            {
              title: intl.formatMessage({ id: 'support_manage_operate' }),
              key: 'action',
              render: (text, record) => {
                return (
                  <div className="support-operate">
                    <OperateSpan onClick={this.toggleEdit.bind(this, record)}>
                      <IconTip
                        title={intl.formatMessage({
                          id: 'support_manage_oprate_edit'
                        })}
                        type="75bianji"
                      />
                    </OperateSpan>
                    <OperateSpan
                      onClick={this.deleteSupport.bind(this, record.id)}
                    >
                      <IconTip
                        title={intl.formatMessage({
                          id: 'support_manage_oprate_delete'
                        })}
                        type="shanchu"
                      />
                    </OperateSpan>
                  </div>
                );
              }
            }
          ]}
          dataSource={allSupports}
          rowKey={record => record.id}
          pagination={
            allSupports.length > 10
              ? {
                  total: allSupports.length,
                  pageSize: 10
                }
              : false
          }
        />
        <SupportEditModal
          visible={showEdit}
          allSupports={allSupports}
          editSupport={editSupport}
          dispatch={dispatch}
          onCancel={this.toggleEdit}
          intl={this.props.intl}
        />
      </div>
    );
  }

  onChangeFrontDeskPhone = e => {
    this.props.dispatch({
      type: 'support/update',
      payload: { frontDeskPhone: e.target.value }
    });
  };

  onSaveFrontDeskPhone = () => {
    const promise = new Promise((resolve, reject) => {
      this.props.dispatch({
        type: 'support/updateFrontDeskPhone',
        resolve,
        reject
      });
    });
    promise.then(
      () => {
        this.setState({ editDeskPhone: false });
      },
      msg => {
        Modal.error({ content: msg });
      }
    );
  };

  toggleEdit = editSupport => {
    const { showEdit } = this.state;
    if (showEdit) {
      this.setState({ showEdit: false });
    } else {
      this.setState({ editSupport, showEdit: true });
    }
  };

  deleteSupport = supportId => {
    const { intl } = this.props;
    Modal.confirm({
      content: intl.formatMessage({ id: 'support_manage_delete_msg' }),
      onOk: () => {
        const promise = new Promise((resolve, reject) => {
          this.props.dispatch({
            type: 'support/delete',
            supportId,
            resolve,
            reject
          });
        });
        promise.then(
          () => {},
          msg => {
            Modal.error({ content: msg });
          }
        );
      }
    });
  };
}

const mapStateToProps = state => {
  const { support } = state;
  return { ...support };
};

export default connect(mapStateToProps)(injectIntl(SupportManage));



// WEBPACK FOOTER //
// ./src/routes/SystemConfig/SupportManage.js